import ContactComponent from '../components/contact-us/contactUs'

const Contact = () => <ContactComponent />

export default Contact;